export type MassnahmeParts = { nummer: string; bezeichnung: string }

export function splitMassnahmeSelection(selection: unknown): MassnahmeParts {
  const s = selection == null ? '' : String(selection)
  const sep = s.indexOf(' - ')
  if (sep < 0) return { nummer: '', bezeichnung: s }
  return { nummer: s.slice(0, sep).trim(), bezeichnung: s.slice(sep + 3).trim() }
}

export function composeMassnahmeSelection(nummer: string, bezeichnung: string): string {
  return `${nummer.trim()} - ${bezeichnung.trim()}`
}

export function normalizeMassnahmeNummer(value: unknown): string {
  return (value == null ? '' : String(value)).replace(/\s+/g, '')
}

export function findMassnahmeSelectionByNummer(
  nummer: string,
  selections: string[],
): string | null {
  const target = normalizeMassnahmeNummer(nummer)
  for (const sel of selections) {
    if (normalizeMassnahmeNummer(splitMassnahmeSelection(sel).nummer) === target) return sel
  }
  return null
}
